import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Row = ({ title, text, checked, onChange, testId }) => (
  <div className="flex items-center justify-between gap-4 border rounded-md p-3">
    <div>
      <p className="font-medium text-sm">{title}</p>
      <p className="text-xs text-gray-600">{text}</p>
    </div>
    <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />
  </div>
);

export const EmailSettingsCard = ({ tenantId }) => {
  const [s, setS] = useState(null);
  const params = tenantId ? { tenant_id: tenantId } : {};

  useEffect(() => {
    axios.get(`${API}/tenant/email-settings`, { params }).then((r) => setS(r.data)).catch(() => {});
  }, [tenantId]);

  if (!s) return null;

  const update = async (key, value) => {
    const next = { ...s, [key]: value };
    try {
      await axios.put(`${API}/tenant/email-settings`, next, { params });
      setS(next);
      toast.success(value ? 'Emails activés' : 'Emails désactivés');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Modification impossible');
    }
  };

  return (
    <Card data-testid="email-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Mail className="w-5 h-5 text-blue-700" /> Emails de l’établissement</CardTitle>
        <CardDescription>Les notifications dans l’application restent toujours actives ; ces réglages ne concernent que les emails.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Row title="Relances d’impayés par email" text="Relances manuelles et automatiques envoyées aux parents."
          checked={s.email_invoice_reminders} onChange={(v) => update('email_invoice_reminders', v)} testId="email-invoice-reminders-switch" />
        <Row title="Contrôles par email" text="Annonce d’un contrôle planifié et rappel la veille à 18h aux élèves et parents."
          checked={s.email_notifications} onChange={(v) => update('email_notifications', v)} testId="email-tests-switch" />
      </CardContent>
    </Card>
  );
};

export default EmailSettingsCard;
